
<v-menu
    v-model ="show"
    :position-x ="68"
    :position-y="222"
    absolute
    offset-y
    nudge-top="-4"
    @input  = "onInput"
>
    <div class="history-title primary white--text">
        {{ $t('unit.tzb.history') }}
    </div>
    <v-list>
        <v-list-item
            v-for  = "(item, index) in history"
            :key   = "index"
            @click = "onSelected(item)"
        >
            <div class="v-flex">
                <div class="history-date">
                    {{ formatDate (item.date) }}
                </div>
                <div >
                    {{ item.technician }}
                </div>
            </div>
        </v-list-item>
    </v-list>
</v-menu>
